import './site-header.scss';
import AjaxLoad from '../../lib/ajax-load';
import autoComplete from 'pixabay-javascript-autocomplete';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class SiteHeader {
    constructor () {
        this.$siteHeader = document.querySelector('[data-site-header]');
        this.$siteMain = document.querySelector('.site-main');
        this.$siteHeaderInner = document.querySelector('.site-header__inner');
        this.lastScrollPos = 0;
        this.scrollDistance = 200;
        this.isAnimating = false;
        this.$navItems = [].slice.call(this.$siteHeader.querySelectorAll('[data-nav="item"]'));
        this.$navMain = this.$siteHeader.querySelector('[data-nav="main"]');
        this.$subNavContainer = this.$siteHeader.querySelector('[data-nav="sub-container"]');
        this.$navSwitch = document.querySelector('#nav__switch');
        this.$searchSwitch = document.querySelector('#search__switch');
        this.editmode = document.body.getAttribute('data-editmode') === '';

        // Search
        this.$searchInput = this.$siteHeader.querySelector('[data-nav-search="input"]');
        this.$searchForm = this.$siteHeader.querySelector('[data-nav-search="form"]');
        this.searchAutocompleteURL = this.$searchForm.getAttribute('data-autocomplete');
        this.$searchAutocomplete = this.$searchForm.querySelector('[data-search-autocomplete]');
        this.$searchSubmit = this.$siteHeader.querySelector('[data-nav-search="submit"]');
        this.$searchResults = document.querySelector('[data-nav-search="results"]');
        this.$searchResultsTarget = document.querySelector('[data-nav-search="target"]');
        this.$tabNavigation = document.querySelector('.product-detail .tab-navigation');

        this.size = '';
    }

    initialize () {
        this.checkStatus();
        this.setEvents();

        if (this.$searchInput) {
            this.initAjaxAutoComplete();
        }
    }

    setEvents () {
        const stdHeight = 69;

        this.$navItems.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                if (this.size === 'desktop') {
                    if (item.nextElementSibling) {
                        if (this.$siteHeader.classList.contains('is--visible')) {
                            this.$subNavContainer.style.height = item.nextElementSibling.firstElementChild.scrollHeight + stdHeight + 'px';
                        } else {
                            this.$subNavContainer.style.height = item.nextElementSibling.firstElementChild.scrollHeight + 93 + 'px';
                        }
                    }
                    item.closest('li').classList.add('is--open');
                    this.$subNavContainer.classList.add('is--open');
                }
            });

            if (item.nextElementSibling) {
                item.nextElementSibling.addEventListener('mouseenter', () => {
                    if (this.size === 'desktop') {
                        item.closest('li').classList.add('is--open');
                        this.$subNavContainer.classList.add('is--open');
                    }
                });

                item.nextElementSibling.addEventListener('mouseleave', () => {
                    if (this.size === 'desktop') {
                        item.closest('li').classList.remove('is--open');
                        this.$subNavContainer.classList.remove('is--open');
                    }
                });

                item.nextElementSibling.querySelector('[data-nav="back"]').addEventListener('click', () => {
                    item.closest('.is--open').classList.remove('is--open');
                    this.$navMain.classList.remove('is--open');
                    this.$subNavContainer.classList.remove('is--open');
                });
            }

            item.addEventListener('mouseleave', () => {
                if (this.size === 'desktop') {
                    item.closest('li').classList.remove('is--open');
                    this.$subNavContainer.classList.remove('is--open');
                }
            });

            item.addEventListener('click', () => {
                if (this.size === 'mobile') {
                    if (item.classList.contains('is--open')) {
                        item.classList.remove('is--open');
                        this.$subNavContainer.classList.remove('is--open');
                    } else {
                        this.$navMain.classList.add('is--open');
                        item.classList.add('is--open');
                        this.$subNavContainer.classList.add('is--open');
                    }
                }
            });
        });

        this.$navSwitch.addEventListener('change', () => {
            if (this.$navSwitch.checked) {
                if (this.$searchSwitch.checked) {
                    this.$navSwitch.checked = false;
                    disableBodyScroll(this.$siteHeader);
                    this.$searchSwitch.checked = false;

                    setTimeout(() => {
                        this.$navSwitch.checked = true;
                    }, 500);
                }
                disableBodyScroll(this.$siteHeader);
                this.$searchSwitch.checked = false;
                this.$siteHeader.classList.add('has--height-fix');
            } else {
                enableBodyScroll(this.$siteHeader);

                [].slice.call(this.$siteHeader.querySelectorAll('.is--open')).forEach((value) => {
                    value.classList.remove('is--open');
                });

                this.$siteHeader.classList.remove('has--height-fix');
                this.checkStatus(true);
            }
        });

        this.$searchSwitch.addEventListener('change', () => {
            if (this.size === 'mobile') {
                if (this.$searchSwitch.checked) {
                    if (this.$navSwitch.checked) {
                        this.$searchSwitch.checked = false;
                        disableBodyScroll(this.$siteHeader);
                        this.$navSwitch.checked = false;

                        setTimeout(() => {
                            this.$searchSwitch.checked = true;
                        }, 500);
                    }

                    disableBodyScroll(this.$siteHeader);
                    this.$siteHeader.classList.add('has--height-fix');
                    this.$searchInput.focus();
                } else {
                    enableBodyScroll(this.$siteHeader);
                    this.$searchInput.blur();
                    this.$searchResults.classList.remove('is--visible');
                    this.$siteHeader.classList.remove('has--height-fix');
                }
            } else {
                if (this.$searchSwitch.checked) {
                    disableBodyScroll(this.$siteHeader);
                    this.$searchInput.focus();
                } else {
                    this.$searchResults.classList.remove('is--visible');
                    enableBodyScroll(this.$siteHeader);
                    this.$searchInput.blur();
                }
            }
        });

        if (this.$searchForm) {
            this.$searchForm.addEventListener('submit', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const ajaxLoad = new AjaxLoad(this.$searchForm.getAttribute('action') + '?q=' + this.$searchInput.value, {
                    requestMethod: 'GET',
                    onSuccess: (result) => {
                        this.$searchInput.blur();

                        const data = JSON.parse(result);
                        this.$searchResultsTarget.textContent = '';

                        if (data.results.length > 0) {
                            this.generateSearchTeaser(data);
                            this.$searchResults.classList.add('is--visible');
                        } else {
                            this.generateNoResult();
                            this.$searchResults.classList.add('is--visible');
                        }
                    }
                });
                ajaxLoad.initialize();
            });

            this.$searchResults.addEventListener('click', (e) => {
                if (e.target.classList.contains('grid-container')) {
                    this.$searchResults.classList.remove('is--visible');
                    enableBodyScroll(this.$siteHeader);
                }
            });
        }
    }

    generateNoResult () {
        const noResult = document.createElement('div');
        noResult.classList.add('nav__search-noresult');
        noResult.innerHTML = '<p>' + this.$searchInput.getAttribute('data-no-results') + '</p>';
        noResult.innerHTML = noResult.innerHTML.replace('****', '<strong>' + this.$searchInput.value + '</strong>');
        this.$searchResultsTarget.appendChild(noResult);
    }

    generateSearchTeaser (data) {
        const addLink = (cta) => {
            const action = document.createElement('div');
            action.classList.add('nav__search-actions');

            action.innerHTML = '<a href="' + this.$searchForm.getAttribute('action') + '?q=' + this.$searchInput.value + '" class="textlink textlink--arrow-right icon-arrow_right">' + cta + '</a>';
            this.$searchResultsTarget.appendChild(action);
        };

        data.results.forEach((entry) => {
            const item = document.createElement('a');
            item.classList.add('nav__search-item');
            item.href = entry.uri;
            let template = '';
            let category = entry.category;

            if (typeof category === 'undefined') {
                category = pageTeaserCategoryTrans; //eslint-disable-line
            }
            template = typeof entry.image !== 'undefined' ? '<div class="nav__search-item-content">' : '<div class="nav__search-item-content has--no-image">';
            template += '<p class="nav__search-item-category">' + category + '</p>';
            template += '<p class="nav__search-item-title">' + entry.headline + '</p></div>';

            if (typeof entry.image !== 'undefined') {
                template += '<div class="nav__search-item-image">';
                template += '<img src="' + entry.image + '" alt="' + entry.headline + '" width="90" height="60">';
                template += '</div>';
            }

            item.innerHTML = template;
            this.$searchResultsTarget.appendChild(item);
        });

        addLink(data.cta);
        //
        // if (link is available) {
        //     addLink();
        // }
    }

    setAnimating () {
        this.isAnimating = true;
        setTimeout(() => {
            this.isAnimating = false;
        }, 500);
    }

    checkNavigation (position, direction) {
        if (!this.editmode) {
            if (direction === 'up' && this.isAnimating === false) {
                if (this.lastScrollPos === 0) {
                    this.lastScrollPos = position;
                }

                if (position > this.scrollDistance) {
                    if ((this.lastScrollPos - position) >= this.scrollDistance) {
                        if (this.$siteHeader.classList.contains('is--hidden')) {
                            this.$siteHeader.classList.add('is--visible');
                            this.$siteHeader.classList.remove('is--hidden');

                            if (this.$tabNavigation) {
                                this.$tabNavigation.classList.add('is--visible');
                                this.$tabNavigation.classList.remove('is--hidden');
                            }
                        } else {
                            this.$siteHeader.classList.add('is--visible');
                            if (this.$tabNavigation) {
                                this.$tabNavigation.classList.add('is--visible');
                            }
                        }
                        // this.setAnimating();
                    }
                } else {
                    if (this.$siteHeader.classList.contains('is--hidden')) {
                        this.$siteHeader.classList.add('is--visible');
                        this.$siteHeader.classList.remove('is--hidden');
                        if (this.$tabNavigation) {
                            this.$tabNavigation.classList.add('is--visible');
                            this.$tabNavigation.classList.remove('is--hidden');
                        }
                    } else {
                        this.$siteHeader.classList.add('is--visible');
                        if (this.$tabNavigation) {
                            this.$tabNavigation.classList.add('is--visible');
                        }
                    }

                    if (window.innerWidth >= 1024 && (position <= 50 && position >= 0)) {
                        if (this.$siteHeader.classList.contains('is--fixed')) {
                            this.$siteHeaderInner.style.height = 70 + (50 - position) + 'px';
                        } else {
                            if (!this.$siteHeader.classList.contains('is--visible')) {
                                this.$siteMain.style.marginTop = 60 + (60 - position) + 'px';
                            }
                        }
                    }
                    // this.setAnimating();
                }
            }

            if (direction === 'down' && this.isAnimating === false) {
                if (this.lastScrollPos !== 0) {
                    this.lastScrollPos = 0;
                }

                if (position > this.scrollDistance) {
                    if (!this.$siteHeader.classList.contains('is--fixed')) {
                        this.$siteHeaderInner.style.height = '';
                        this.$siteMain.style.marginTop = '';
                        this.$siteHeader.classList.add('is--fixed');
                    }
                    if (this.$siteHeader.classList.contains('is--visible')) {
                        this.$siteHeaderInner.style.height = '';
                        this.$siteMain.style.marginTop = '';
                        this.$siteHeader.classList.remove('is--visible');
                        this.$siteHeader.classList.add('is--hidden');
                        if (this.$tabNavigation) {
                            this.$tabNavigation.classList.remove('is--visible');
                            this.$tabNavigation.classList.add('is--hidden');
                        }
                    }
                } else {
                    if (this.$siteHeader.classList.contains('is--fixed') && window.innerWidth >= 1024) {
                        if (position <= 50 && position >= 0) {
                            this.$siteHeaderInner.style.height = 70 + (50 - position) + 'px';
                        }
                    }
                }
            }

            if (position === 0) {
                this.$siteHeader.classList.remove('is--fixed');
                this.$siteHeader.classList.remove('is--visible');
                if (this.$tabNavigation) {
                    this.$tabNavigation.classList.remove('is--visible');
                }
                this.$siteMain.style.marginTop = '';
            }
        }
    }

    checkStatus (close) {
        if (close === true) {
            if (this.$navMain.classList.contains('is--active')) {
                this.$navMain.classList.remove('is--active');
                document.body.style.overflow = '';
            }

            // const $active = this.$navMain.querySelector('.is--active');

            // if ($active) {
            //     $active.classList.remove('is--active');
            // }
        }

        if (window.innerWidth >= 1024) {
            if (window.innerWidth >= 1024) {
                if (this.$navMain.classList.contains('is--active')) {
                    this.$navMain.classList.remove('is--active');
                    document.body.style.overflow = '';
                }
            }
            this.size = 'desktop';
        } else {
            if (window.innerWidth < 1024) {
                this.size = 'mobile';
            }
        }
    }

    initAjaxAutoComplete () {
        const CustomAutoComplete = autoComplete;

        this.$searchInput.addEventListener('focus', () => {
            this.searchField = new CustomAutoComplete({
                selector: this.$searchInput,
                source: (term, response) => {
                    this.$searchSubmit.disabled = this.$searchInput.value.length < 3;
                    const ajaxLoad = new AjaxLoad(this.searchAutocompleteURL + '?q=' + this.$searchInput.value, {
                        requestMethod: 'GET',
                        onSuccess: (resultText) => {
                            const data = JSON.parse(resultText);
                            response(data.result);
                        }
                    });
                    ajaxLoad.initialize();
                },
                minChars: 3,
                onSelect: () => {
                    this.$searchSubmit.click();
                }
            });
        });

        this.$searchInput.addEventListener('blur', () => {
            if (this.searchField) {
                this.searchField.destroy();
            }
        });
    }
}

export { SiteHeader };
